import { baseApi } from './baseApi';
import { QRCodeData, QRVerifyResponse } from '../../types';

export const qrApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateQRCode: builder.mutation<QRCodeData, { shopName?: string }>({
      query: (body) => ({
        url: '/qr/generate/owner',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['QRCode'],
    }),
    verifyQRToken: builder.mutation<
      QRVerifyResponse,
      { token: string; clientSessionId: string; customerLat?: number; customerLng?: number }
    >({
      query: (body) => ({
        url: '/qr/verify',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGenerateQRCodeMutation, useVerifyQRTokenMutation } = qrApi;
